<template>
  <div>
    <h3>Contact</h3>
    <table class="table table-condensed">
      <tbody>
        <template v-for="row in rows">
          <tr
            v-if="row.show === true || (row.show === undefined && row.value)"
            :key="row.title"
          >
            <th>{{ row.title }}</th>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <td v-html="row.value" />
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
import scholenRepository from '../../repositories/scholenRepository';

export default {
  props: {
    school: {
      required: true,
      type: Object,
    },
  },
  data() {
    const { school } = this;
	const linkStyle = 'margin-right: initial; display: inline; font-family: inherit; font-size: inherit; background-color: transparent; text-decoration: none; color: inherit; border-bottom: 3px solid #b4e7f8; box-shadow: inset 0 -3px 0 #b4e7f8; transition: 0.2s background-color, 0.2s border-top;';

    return {
      rows: [
        {
          title: 'contactpersoon',
          value: school.contactpersoon,
        },
        {
          title: 'adres',
          value: `${school.straat} ${school.huisnr}<br/>
          ${school.pc} ${school.plaats}`,
        },
        {
          title: 'telefoon',
          value: this.$options.filters.phonenumber(school.telefoon),
          show: isset(school.telefoon),
        },
        {
          title: 'email',
          value: `<a href="mailto:${school.email}" style="${linkStyle}">${school.email}</a>`,
          show: isset(school.email),
        },
        {
          title: 'website',
          value: `<a class="website" target="_blank"
            href="${school.website}"style="${linkStyle}">${websitify(school.website)}</a>`,
          show: isset(school.website),
        },
        {
          title: 'twitter',
          value: `<a href="https://twitter.com/${school.twitter}">
            ${school.twitter}</a>`,
          show: isset(school.twitter),
        },
      ],
    };
  },
  async created() {
    const linkStyle = 'margin-right: initial; display: inline; font-family: inherit; font-size: inherit; background-color: transparent; text-decoration: none; color: inherit; border-bottom: 3px solid #b4e7f8; box-shadow: inset 0 -3px 0 #b4e7f8; transition: 0.2s background-color, 0.2s border-top;';

    if (this.school.bestuur_bgn) {
      const response = await scholenRepository.listBesturen({
        'where[bgn]': this.school.bestuur_bgn,
      });
      const bestuur = response.data[0];
      this.rows.push({
        title: 'bestuur',
        value: `<a href="${process.env.VUE_APP_BASE_URL}/besturen/bestuur/${this.school.bestuur_bgn}" style="${linkStyle}">${bestuur.naam}</a>`,
        class: 'bestuur',
      });
    }
  },
};

function isset(value) {
  return !!value;
}

function websitify(value) {
  let websiteValue = value;
  websiteValue = websiteValue.replace(/http:\/\/www\./gi, '');
  websiteValue = websiteValue.replace(/www\./gi, '');
  websiteValue = websiteValue.replace(/http:\/\//gi, '');
  return websiteValue;
}
</script>

<style scoped>
a.website{
  margin-right: initial;
  display: inline;
  font-family: inherit;
  font-size: inherit;
  background-color: transparent;
  text-decoration: none;
  color: inherit;
  border-bottom: 3px solid #b4e7f8;
  box-shadow: inset 0 -3px 0 #b4e7f8;
  transition: 0.2s background-color, 0.2s border-top;
}

.adres {
  /* Add specific styles for adres if needed */
}

a.website {
  /* Add specific styles for website if needed */
}

.bestuur {
  /* Add specific styles for bestuur if needed */
}
</style>